/* pages/mail/Mail.jsx */
import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import DatatableSection from "../../components/datatableSection/DatatableSection";
import MailHome from "./components/MailsHome";

const Mail = () => {
  return (
    <>
      <Sidebar />
      <MainSection>
        <SectionHeader title="Mails" />
        <DatatableSection>
          {/* Only renders the list home */}
          <MailHome />
        </DatatableSection>
      </MainSection>
    </>
  );
};

export default Mail;